<ng-container *transloco="let t">
  <div
    class="footer-block__info--title"
    dataAttribute
    componentName="footer-info-payment-title"
  >
    {{ t('FOOTER.PAYMENT_METHODS') }}
  </div>
  <a
    target="_blank"
    class="payment-link"
    [routerLink]="ROUTES.PAYMENT_INFO"
    dataAttribute
    componentName="footer-info-payment-link"
  >
    <div class="payment-images">
      @for (image of paymentImages; track image) {
        <div class="image" [style.padding]="image.padding">
          <img
            [ngSrc]="image.src"
            [width]="image.width"
            [height]="image.height"
            [alt]="image.alt"
          />
        </div>
      }
    </div>
    <span class="body text--bold" dataAttribute componentName="footer-info-payment-text">
      {{ t('FOOTER.SAFE_PAYMENTS_INFO') }}
    </span>
  </a>

  <a
    *showContentFor="BuildType.ru"
    class="payment-details-link"
    [routerLink]="ROUTES.PAYMENT_DETAILS"
    dataAttribute
    componentName="footer-info-payment-details-link"
  >
    {{ t('FOOTER.PAYMENT_DETAILS') }}
  </a>
</ng-container>
